'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NotificationEvent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _string = require('utils/string');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotificationEvent(_ref) {
  var notification = _ref.notification,
      handleDecline = _ref.handleDecline,
      handlePublish = _ref.handlePublish,
      polyglot = _ref.polyglot,
      showEventModal = _ref.showEventModal;
  var _notification$entry$i = notification.entry.item,
      id = _notification$entry$i.id,
      start_date = _notification$entry$i.start_date,
      end_date = _notification$entry$i.end_date,
      title = _notification$entry$i.title,
      description = _notification$entry$i.description,
      venue = _notification$entry$i.venue,
      tags = _notification$entry$i.tags,
      thumbnail_url = _notification$entry$i.thumbnail_url,
      types = _notification$entry$i.types;

  var startDate = (0, _moment2.default)(start_date).format('Do MMMM');
  var endDate = end_date ? (0, _moment2.default)(end_date).format('Do MMMM') : startDate; // eslint-disable-line camelcase
  var thumbnailUrl = thumbnail_url; // eslint-disable-line camelcase

  return _react2.default.createElement(
    'div',
    { className: 'notification-event-item' },
    _react2.default.createElement(
      'div',
      { className: 'event-image' },
      thumbnailUrl && _react2.default.createElement('img', { src: thumbnailUrl, alt: title }),
      !thumbnailUrl && _react2.default.createElement('span', { className: 'icon-cg-buddy placeholder' }),
      _react2.default.createElement(
        'div',
        { className: 'dates' },
        startDate,
        startDate !== endDate ? ' ' + polyglot.t('notification.activity.request.event.to') + ' ' + endDate : ''
      ),
      _react2.default.createElement(
        'div',
        { className: 'meta' },
        _react2.default.createElement(
          'h4',
          { className: 'title' },
          title
        ),
        _react2.default.createElement(
          'h6',
          { className: 'location' },
          venue.data && _react2.default.createElement(
            'span',
            null,
            venue.data.name
          )
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'event-content' },
      _react2.default.createElement(
        'h2',
        { className: 'type' },
        types.data && types.data.slice(0, 1).map(function (tag) {
          return _react2.default.createElement(
            'span',
            { key: 'theme-' + tag.id },
            tag.name
          );
        }),
        types.data.length > 1 && _react2.default.createElement(
          'small',
          { className: 'mute' },
          polyglot.t('notification.activity.request.event.more_themes', types.data.length - 1)
        )
      ),
      _react2.default.createElement(
        'p',
        null,
        (0, _string.trunc)(description, 500, true)
      ),
      _react2.default.createElement(
        'div',
        { className: 'themes' },
        tags.data && tags.data.slice(0, 3).map(function (tag) {
          return _react2.default.createElement(
            'span',
            { key: 'tag-' + tag.id },
            _react2.default.createElement(
              'span',
              { className: 'label' },
              tag.name
            ),
            ' '
          );
        }),
        tags.data.length > 3 && _react2.default.createElement(
          'span',
          { className: 'mute' },
          ' ',
          polyglot.t('notification.activity.request.event.more_tags', tags.data.length - 3)
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'event-actions' },
        _react2.default.createElement(
          'div',
          { className: 'buttons' },
          _react2.default.createElement(
            'button',
            {
              className: 'btn btn-default btn-outline',
              onClick: handleDecline.bind(null, notification)
            },
            polyglot.t('notification.activity.button.reject')
          ),
          '\xA0',
          _react2.default.createElement(
            'button',
            {
              className: 'btn btn-primary',
              onClick: handlePublish.bind(null, notification)
            },
            polyglot.t('notification.activity.button.publish')
          )
        ),
        _react2.default.createElement(
          'b',
          null,
          _react2.default.createElement(
            'a',
            { onClick: showEventModal.bind(null, id) },
            polyglot.t('notification.activity.request.event.show')
          )
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Notification/NotificationEvent.js
// module id = 2236
// module chunks = 0